/** Abre el panel del asistente Flow IA ya montado en Layout (sin nuevo bot). */
export function openFlowIaAssistant() {
  const fab = document.querySelector('.flow-ia-fab:not(.flow-ia-fab--disabled)');
  if (fab instanceof HTMLElement) {
    fab.click();
  }
}
